<template>
    <div>
        <div v-if="show" class="box">
            <div>
                <iframe :src="fileURL" scrolling=auto width="100%" :height="h" frameborder='0'/>
            </div>
        </div>
        <div v-else class="box">
            <div v-if="showFlv" style="height:100%">
                <div id="msess"></div>
            </div>
            <div v-else style="height:100%">
                <xgplayer id="video" :options="playerOptions"></xgplayer>
            </div>
        </div>
    </div>
</template>
<script>
import FlvJsPlayer from 'xgplayer-flv.js';
// import 'xgplayer-mp4';
    export default { 
        data(){
            return{
                fileURL:sessionStorage.fileURL,
                playerOptions:{
                    id:'video',
                    url: sessionStorage.fileURL,
                    poster: '',
                    width: '100%',
                    autoplay: true
                },
                show:false,
                showFlv:false,
                playerFlvOptions:{
                    id: 'msess',
                    url: sessionStorage.fileURL,
                    poster: '',
                    autoplay: true,
                    width: '100%',
                    height:'100%',
                    hasVideo: true,
                    hasAudio: true,
                    flvOptionalConfig: {
                        enableWorker: true
                    }
                },
                h:0
            }
        },
        mounted() {
            this.h = window.innerHeight;
            document.getElementsByClassName("box")[0].style.height = this.h + "px";
            
            // console.log(sessionStorage.fileURL,'sessionStorage.fileURL========')
            if(sessionStorage.fileURL.indexOf('.pdf')>0){
                this.show = true;
                this.fileURL = sessionStorage.fileURL;
            }else{
                this.show = false;
                if(sessionStorage.fileURL.indexOf('.mp4')>-1){
                    this.showFlv = false;
                    this.playerOptions.url = sessionStorage.fileURL;
                }else{
                    this.showFlv = true;
                    var that = this;
                    setTimeout(function(){
                       var Player = new FlvJsPlayer(that.playerFlvOptions);
                       that.$emit('player', Player);
                    },200);
                }
            }
        },
        methods: {

        }
    }
</script>
<style lang="less" scoped>
    /deep/ .xgplayer{
        height: 100%!important;
        width: 100%!important;
    }
    /deep/ #msess .xgplayer-start svg{
        margin: 0!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/file/vFile.vue